import script from "./addComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./addComponent.vue?vue&type=script&setup=true&lang=js"

import "./addComponent.vue?vue&type=style&index=0&id=84fe2bc2&lang=scss&scoped=true"
import "./addComponent.vue?vue&type=style&index=1&id=84fe2bc2&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84fe2bc2"]])

export default __exports__